<template>
  <div id="NotFound" class="fullheight" style="background-color: #F7F0E6">
    <CContainer fluid class="fullheight">
      <CRow class="align-items-center justify-content-center fullheight">
        <CCol cols="12" md="6" class="text-center">
          <div class="p-5 bg-white" style="border-radius: 8px;">
            <h1 style="font-size: 72px; font-weight: bold;">404</h1>
            <h4 class="mb-3">Página no encontrada</h4>
            <p class="text-muted mb-4">
              La página que estás buscando no existe o fue movida.
            </p>

            <CButton color="info" @click="goHome">
              Volver al inicio
            </CButton>
          </div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goHome() {
      this.$router.push({ name: 'Login' });
    }
  }
};
</script>

<style scoped>
.fullheight {
  min-height: 100vh;
}
</style>
